import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000, // 30s — accounts for Lambda cold-start (~8-15s)
  headers: { 'Content-Type': 'application/json' },
});

// Retry once on timeout / network error (handles Lambda cold-start)
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const config = err.config as typeof err.config & { _retried?: boolean };
    const isTimeout = err.code === 'ECONNABORTED' || err.message?.includes('timeout');
    const isNetwork = !err.response;

    if ((isTimeout || isNetwork) && !config._retried) {
      config._retried = true;
      console.warn('API: retrying after timeout/network error…');
      return api(config);
    }

    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', err.response?.data || err.message);
    }
    return Promise.reject(err);
  }
);

export default api;
